import type { ApiClient } from "../../api/client";
import type { DeviceStatus } from "../../api/types";
import { Logo } from "../../ui/Logo";
import { TermsGate } from "./TermsGate";

interface Props {
  api: ApiClient;
  status: DeviceStatus;
  /** Accepted: the till opens. */
  onAccepted: () => void;
}

/**
 * The start-up screen until the owner has accepted the terms in effect (the server answers 423
 * everywhere else), like an app store's terms screen: the acceptance window cannot be closed.
 */
export function TermsScreen({ api, status, onAccepted }: Props) {
  return (
    <main className="app terms-start">
      <header className="top">
        <Logo />
        <span className="spacer" />
        <span className="muted">{status.shop.name}</span>
      </header>
      <TermsGate api={api} mode={status.terms.need === "reaccept" ? "reaccept" : "first"} onAccepted={onAccepted} />
    </main>
  );
}
